import { BaseAPI } from "@/api/base.api";
import { TipoVeiculo } from "@/models/tipo_veiculo";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

import { VUE_APP_SIT_API_URL } from "@/commons/config";
import { map } from "rxjs/operators";

export class TipoVeiculoAPI extends BaseAPI<TipoVeiculo> {
  constructor() {
    super();
    this.apiUrl = `${VUE_APP_SIT_API_URL}`;
  }

  public getAll(): AxiosObservable<TipoVeiculo[]> {
    return this.axios.post(`${this.apiUrl}/boletos/tiposVeiculo`, {}).pipe(
      map((response: any) => {
        return response.tiposVeiculo;
      })
    );
  }
}
